import React from 'react';
import { Modal, Badge } from 'react-bootstrap';
import moment from 'moment';
import { hasAValue, formatToDayNameString } from '../../utils/SharedFunctions';
import { Link } from 'react-router-dom';
import instoreIcon from '../../style/images/icons/instore.png';
import urlIcon from '../../style/images/icons/url.png';
import onlineIcon from '../../style/images/icons/online.png';
import BelgiumIcon from '../../style/images/icons/Belgium.png';
import NetherlandsIcon from '../../style/images/icons/Netherlands.png';

const NotificationDetailModal = ({
    show,
    onHide,
    notification,
    segmentation,
    onStartSending,
    showActionButtons = true
}) => {
    const typesIcons = {
        url: urlIcon,
        instore: instoreIcon,
        cashback: onlineIcon,
    };

    const typesLabels = {
        url: "URL",
        instore: "Instore",
        cashback: "Online",
    };

    const sessions = [
        {label: "Last session within 3 days ago", value: "< 3"} ,
        {label: "Last session more than 3 days ago", value: "> 3"},
        {label: "Last session within 5 days ago", value: "< 5"},
        {label: "Last session more than 5 days ago", value: "> 5"},
        {label: "Last session within 7 days ago", value: "< 7"},
        {label: "Last session more than 7 days ago", value: "> 7"},
        {label: "Last session within 14 days ago", value: "< 14"},
        {label: "Last session more than 14 days ago", value: "> 14"}
    ];

    const formatDateTime = (dateString) => {
        return moment(dateString).format('MMMM D, YYYY [at] h:mm A');
    };

    const getTimeUntil = (dateString) => {
        return moment(dateString).fromNow();
    };

    return (
        <Modal className="modal fade" size="xl" show={show} onHide={onHide}>
            <div className="" role="document">
                <div className="">
                    <form>
                        <div className="modal-header">
                            <h4 className="modal-title fs-20">Notification</h4>
                            <button type="button" className="btn-close" onClick={onHide}
                                    data-dismiss="modal"></button>
                        </div>
                        {hasAValue(notification) && <div className="modal-body">
                            <div className="card border-top shadow">
                                <div className="card-header border-0 pb-0">
                                    <h2 className="card-title">Overview</h2>
                                    {
                                        notification.status === 'draft' ?
                                        (
                                            <div className='d-flex align-items-center text-warning'>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{'width': '20px', 'fill': '#FB9F44'}} className='me-2'><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                                                Draft
                                            </div>
                                        )
                                        : notification.status === 'sent' ?
                                        (
                                            <div className='d-flex align-items-center text-green'>
                                            <svg width="20" height="20" viewBox="0 0 20 20" className='me-2' fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="20" height="20" rx="10" fill="#135846"/>
                                            <path d="M5.91669 10.0002L8.83335 12.9168L14.6667 7.0835" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            Sending Completed on {formatToDayNameString(notification.sentDate)}
                                            </div>
                                        )
                                        :
                                        (
                                            <div className='d-flex align-items-center text-primary'>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{'width': '20px', 'fill': '#0473AE'}} className='me-2'><path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>
                                            Scheduled
                                            </div>
                                        )
                                    }

                                </div>
                                <div className="card-body pb-0">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Type</strong>
                                            <span className="col-9 fw-bold">
                                                <img className='me-2' src={typesIcons[notification.type]} alt=''/>
                                                <span
                                                    className='text-primary'>{typesLabels[notification.type]}</span>
                                            </span>
                                        </li>
                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Company</strong>
                                            <span
                                                className="col-9">{notification.data?.companyName ?? '-'}</span>
                                        </li>
                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Title (NL)</strong>
                                            <span
                                                className="col-9">{notification.notificationData?.titleNl}</span>
                                        </li>

                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Body (NL)</strong>
                                            <span
                                                className="col-9">{notification.notificationData?.bodyNl}</span>
                                        </li>
                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Title (EN)</strong>
                                            <span
                                                className="col-9">{notification.notificationData?.titleEn}</span>
                                        </li>

                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Body (EN)</strong>
                                            <span
                                                className="col-9">{notification.notificationData?.bodyEn}</span>
                                        </li>

                                        {
                                            notification.type.toString().includes("url") ?
                                                <li className="list-group-item d-flex px-0 justify-content-between row">
                                                    <strong className="col-3">Target</strong>
                                                    <span
                                                        className="col-9 fw-bold text-primary">{notification.data?.url}</span>
                                                </li>
                                                :
                                                <li className="list-group-item d-flex px-0 justify-content-between row">
                                                    <strong className="col-3">Target</strong>
                                                    <span
                                                        className="col-9 fw-bold text-primary">{notification.data?.name}</span>
                                                </li>
                                        }

                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Made by</strong>
                                            <span
                                                className="col-9 fw-bold text-primary">{notification.madeBy}</span>
                                        </li>

                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Send Date</strong>
                                            <span
                                                className={"col-9 fw-bold text-primary"}>
                                                 {notification.sentDate
                                                     ? formatToDayNameString(notification.sentDate)
                                                     : '-'}
                                            </span>
                                        </li>

                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-3">Total Audience</strong>
                                            <span
                                                className="col-9 fw-bold text-primary">{notification.totalReceivers}</span>
                                        </li>

                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className="col-md-3 col-sm-10 mb-2">Android</strong>
                                            <div className="col-9 d-flex flex-wrap">
                                                <strong className="col-md-3 col-sm-10 mb-2">Audience</strong>
                                                <strong className="col-md-3 col-sm-10 mb-2">Received</strong>
                                                <strong className="col-md-3 col-sm-10 mb-2">Failed</strong>
                                                <span className="col-md-3 col-sm-10 mb-2"></span>
                                                <span
                                                    className="col-md-3 col-sm-10 fw-bold text-primary">{(hasAValue(notification.firebaseSent) && hasAValue(notification.firebaseFailed)) &&
                                                    (parseInt(notification.firebaseSent) + parseInt(notification.firebaseFailed))}</span>
                                                <span
                                                    className="col-md-3 col-sm-10 fw-bold text-primary">{notification.firebaseSent}</span>
                                                <span
                                                    className="col-md-3 col-sm-10 fw-bold text-primary">{notification.firebaseFailed}</span>
                                            </div>
                                        </li>

                                        <li className="list-group-item d-flex px-0 justify-content-between row">
                                            <strong className={"col-md-3 col-sm-10 mb-2"}>iOS</strong>
                                            <div className={"col-9 d-flex flex-wrap"}>
                                                <strong className="col-md-3 col-sm-10 mb-2">Audience</strong>
                                                <strong className="col-md-3 col-sm-10 mb-2">Received</strong>
                                                <strong className="col-md-3 col-sm-10 mb-2">Failed</strong>
                                                <span className="col-md-3 col-sm-10 mb-2"></span>
                                                <span
                                                    className="col-md-3 col-sm-10 fw-bold text-primary">{(hasAValue(notification.iosSent) && hasAValue(notification.iosFailed)) &&
                                                    (parseInt(notification.iosSent) + parseInt(notification.iosFailed))}</span>
                                                <span
                                                    className="col-md-3 col-sm-10 fw-bold text-primary">{notification.iosSent}</span>
                                                <span
                                                    className="col-md-3 col-sm-10 fw-bold text-primary">{notification.iosFailed}</span>
                                            </div>
                                        </li>
                                        {segmentation && (
                                            <li className="list-group-item d-flex px-0 justify-content-between row">
                                                <strong className="col-3">Recipients Filter</strong>
                                                <div className="col-9">
                                                    <div className="col-md-12 px-0 d-flex flex-column">
                                                        <div className="col-md-12 px-0 d-flex flex-wrap px-0">
                                                            {segmentation.limitationType && <strong
                                                                className="col-md-3 col-sm-10 mb-2">Mode</strong>}
                                                            {segmentation.Gender && <strong
                                                                className="col-md-3 col-sm-10 mb-2">Gender</strong>}
                                                            {segmentation.accountOwner &&
                                                                <strong className="col-md-3 col-sm-10 mb-2">Account
                                                                    Owner</strong>}
                                                        </div>
                                                        <div className="col-md-12 px-0 d-flex flex-wrap px-0">
                                                            {segmentation.limitationType && <span
                                                                className={"col-md-3 col-sm-10 fw-bold text-primary mb-3"}
                                                                style={{'textTransform': 'capitalize'}}>
                                                                        {
                                                                            segmentation.limitationType !== '' ?
                                                                                segmentation.limitationType === 'limited_unlimited' ?
                                                                                    segmentation.limitationType.replaceAll('_', ' & ')
                                                                                    :
                                                                                    segmentation.limitationType.replaceAll('_', ' ')
                                                                                :
                                                                                'Limited & Unlimited'
                                                                        }
                                                                        </span>
                                                            }
                                                            {segmentation.Gender && <span
                                                                className={"col-md-3 col-sm-10 fw-bold text-primary"}
                                                                style={{'textTransform': 'capitalize'}}>{segmentation.Gender}</span>}
                                                            {segmentation.accountOwner && <span
                                                                className={"col-md-3 col-sm-10 fw-bold text-primary"}
                                                                style={{'textTransform': 'capitalize'}}>{segmentation.accountOwner.replaceAll('_', ' ')}</span>}
                                                        </div>
                                                    </div>
                                                    {segmentation?.countries?.map(country => {

                                                        return (
                                                            <div
                                                                className="col-md-12 px-0 d-flex flex-column"
                                                                key={country.name}>
                                                                <div className="col-md-12 px-0 d-flex flex-wrap">
                                                                    <strong
                                                                        className="col-md-3 col-sm-10 mb-2">Country</strong>
                                                                    <strong
                                                                        className="col-md-3 col-sm-10 mb-2">Cities</strong>
                                                                </div>
                                                                <div className="col-md-12 px-0 d-flex flex-wrap">
                                                                        <span
                                                                            className="col-md-3 col-sm-10 fw-bold">
                                                                            {
                                                                                country.name === 'Nederland' ?
                                                                                    <>
                                                                                        <img src={NetherlandsIcon}
                                                                                             className='me-2' alt=''/>
                                                                                        Netherlands
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <img src={BelgiumIcon}
                                                                                             className='me-2' alt=''/>
                                                                                        Belgium
                                                                                    </>
                                                                            }
                                                                        </span>
                                                                    <div
                                                                        className="col-md-9 col-sm-10 mb-2 d-flex flex-wrap">
                                                                        {
                                                                            country.cities.length > 0 ? (
                                                                                country.cities.map((city, index) => (
                                                                                    <span key={index}
                                                                                          className="text-primary fw-bold me-2 text-nowrap">
                                                                                        {city.name}
                                                                                        {index < country.cities.length - 1 && (
                                                                                            <span
                                                                                                className="mx-2">|</span>
                                                                                        )}
                                                                                    </span>
                                                                                ))
                                                                            ) : (
                                                                                <span>All</span>
                                                                            )
                                                                        }
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                    <div className={"col-md-12 px-0 d-flex flex-wrap mt-3"}>
                                                        {
                                                        segmentation &&
                                                            <>
                                                                {segmentation.userSession && <strong
                                                                    className="col-md-3 col-sm-10 mb-2">Session</strong>}
                                                                {segmentation.userSession &&
                                                                    <span
                                                                        className="col-md-12 col-sm-10 fw-bold text-primary">
                                                                        {
                                                                            sessions.filter(item => {
                                                                                return item.value === segmentation.userSession
                                                                            })[0]?.label
                                                                        }
                                                                    </span>
                                                                }
                                                                {segmentation.targetGroup?.toUpperCase() === 'MEMBERS' && (
                                                                    <span
                                                                        className="col-md-12 col-sm-10 fw-bold mt-3">
                                                                        <span style={{
                                                                            color: '#df4ea1',
                                                                            marginRight: '8px',
                                                                            fontWeight: 'bold'
                                                                        }}>✔</span>
                                                                        Send to users with active subscriptions only
                                                                    </span>
                                                                )}
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            {/* Schedule Information Card - Only for scheduled notifications */}
                            {notification?.status === 'scheduled' && notification?.scheduledAt && (
                                 <div className="card border-top shadow mt-3">
                                        <div className="card-header border-0 pb-0">
                                            <h2 className="card-title">Schedule Information</h2>
                                        </div>
                                        <div className="card-body pb-0">
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item d-flex px-0 justify-content-between row">
                                                    <strong className="col-3">Scheduled For</strong>
                                                    <span className="col-9 fw-bold text-primary">
                                                    {formatDateTime(notification.scheduledAt)}
                                                </span>
                                                </li>
                                                <li className="list-group-item d-flex px-0 justify-content-between row">
                                                    <strong className="col-3">Time Until</strong>
                                                    <span className="col-9">
                                                    <Badge bg="warning" text="dark">
                                                        {getTimeUntil(notification.scheduledAt)}
                                                    </Badge>
                                                </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                            )}
                        </div>}



                        <div className="modal-footer">
                            {showActionButtons && (
                                <>
                                    {notification?.status === 'draft' && (
                                        <Link
                                            type="button"
                                            className="btn btn-primary me-auto"
                                            to={`/edit-notification/${notification.id}`}
                                        >
                                            Edit
                                        </Link>
                                    )}
                                    {segmentation && notification?.status === 'draft' && (
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={onStartSending}
                                        >
                                            Start sending notification
                                        </button>
                                    )}
                                </>
                            )}
                            <button type="button" onClick={onHide}
                                    className="btn btn-warning">Close
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
};

export default NotificationDetailModal;
